import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RoleplayApiService } from "../../service/roleplay.service";
import { VeevaVaultService } from "../../service/veeva-vault.service";
import { SelectionModel } from '@angular/cdk/collections';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from '../../service/chat-service';
import { DownloadFileRequest } from "../../model/chat.model";
import { MatMenuTrigger } from '@angular/material/menu';
import { DateFormateService } from "../../date-formate.service";
import { _isNumberValue } from "@angular/cdk/coercion";
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
export interface Action {
  name: string;
  value: string;
}
@Component({
    selector: 'app-document-list',
    templateUrl: './document-list.component.html',
    styleUrl: './document-list.component.scss',
    standalone: false
})
export class DocumentListComponent {
  status: string = 'Active'; 
  menuTriggerData: any;
  showNoSearchResultsMessage: boolean = false;
  displayedColumns: string[] = ['select', 'id','sharepoint_path_id','file_name','status','activation_date','updated_date']
  filterValue: string;
  dataSource = new MatTableDataSource<any>(); // Replace ELEMENT_DATA with your actual data source
  filteredDataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<any>(true, []);
  actions: Action[] = [
    { name: 'Priority 1', value: '1' },
    { name: 'Priority 2', value: '2' },
    { name: 'Priority 3', value: '3' }
  ];
  breadcrumb: any = {};
  selectedActionValue: string; 
 fileID:number ;
  constructor(public Router: Router, private _liveAnnouncer: LiveAnnouncer, 
    public roleplayservice:  RoleplayApiService, private veevaVaultService: VeevaVaultService, private dialog: MatDialog,  
    private toastr: ToastrService, public ChatService: ChatService,private dateFormatService: DateFormateService,private readonly route: ActivatedRoute) {}
  ngOnInit(){
  
    this.route.queryParams.subscribe(params => {
      this.breadcrumb = params;
    });
    this.fileID = Number(this.route.snapshot.queryParamMap.get('id'));
    
    this.loadProfiles( this.fileID);
}

loadProfiles(id:number) {
  this.roleplayservice.getDetailDataSourceList(id).subscribe(res=>{
    this.dataSource=new MatTableDataSource(res);
    this.dataSource.sort= this.sort;
    this.dataSource.paginator= this.paginator;
    this.filteredDataSource = new MatTableDataSource(res);
    this.filteredDataSource.sort = this.sort;
    this.filteredDataSource.paginator = this.paginator;
    this.filterData(this.status);
  
  });
}
downloadFile(docId: string, fileName: string): void {
  const request: DownloadFileRequest = {
    document_id: String(docId),
    document_name: fileName
  };

  this.toastr.info('Downloading file...Please wait', '', { positionClass: 'toast-top-right' });

  this.ChatService.getDownloadFileInfo(request).subscribe({
    next: (res: Blob) => {
      // Create a URL for the blob and simulate a click to download
      const url = window.URL.createObjectURL(res);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url); // Clean up
    },
    complete: () => {
      this.toastr.success('Download Completed.', '', { positionClass: 'toast-top-right' });
    },
    error: (err) => {
      this.toastr.error('Download Failed...Please try again.', '', { positionClass: 'toast-top-right' });
    }
  });
}


// Optional: Set the menu trigger data (if needed)

// onMenuOpened(row: any): void {
//   this.menuTriggerData = row;
// }
formatDate(dateString: string): string {
  if(dateString !== null  && dateString !== undefined) {
    const date = new Date(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Handle midnight
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

    // Format as "dd:mm:yyyy hh:mm tt"
    const formattedDate = `${this.padZero(date.getDate())}:${this.padZero(date.getMonth() + 1)}:${date.getFullYear()} ${formattedHours}:${formattedMinutes} ${ampm}`;

    return formattedDate;
  } else {
    return "";
  }
  
}

// Function to pad zeros for single-digit day or month
padZero(num: number): string {
  return num < 10 ? '0' + num : num.toString();
}
  userinfo(wwid: number) {
    this.Router.navigate(['/app-trainee-detail'], { skipLocationChange: true, queryParams: {id: wwid} });
  }
  applyFilter(value: string) {
    this.filterValue = value.trim().toLowerCase();
    this.filteredDataSource.filter = this.filterValue;
     // Check if there are any items after applying the filter
     if (this.filteredDataSource.filteredData.length === 0 && this.filterValue !== '') {
      this.showNoSearchResultsMessage = true; // Set a flag to indicate no search results
    } else {
      this.showNoSearchResultsMessage = false; // Reset the flag
    }
  }
 
  backbutton() {
    this.Router.navigate(["/app-veeva-vault-dashboard"], { skipLocationChange: true });
  }
  sortData(sort: Sort) {
    if (sort.direction) {
      this._liveAnnouncer.announce(`Sorted ${sort.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  isSomeSelected() {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  toggleSelection(row: any) {
    this.selection.toggle(row);
  }

  rowClicked(row: any): void {
    this.menuTriggerData = row; // Set the row data for the menu
  }

  getActionName(actionValue: string): string {
    const action = this.actions.find(a => a.value === actionValue);
    return action ? action.name : '';
  }

  submitAction() {
    const userId = Number(sessionStorage.getItem('userId'));
    const hasInactiveStatus = this.selection.selected.some(doc => doc.status.toLowerCase() === 'inactive');

    if (!hasInactiveStatus) {
    const selectedProfiles = this.selection.selected.map(profile => ({
      doc_id: profile.doc_id__v,
      document_priority: +this.selectedActionValue,
      updated_by: userId
    }));
    this.selection.selected.forEach(profile => profile.selectedAction = this.selectedActionValue);
    this.veevaVaultService.updatePriority(selectedProfiles).subscribe(response => {
      this.selection.clear(); // Clear the selection after submission
      //this.loadProfiles();
      this.toastr.success('Priority Saved Successfully', '', { positionClass: 'toast-top-right' });        // this.Router.navigate(['/app-home'], { skipLocationChange: true });
    });
   } else {
    this.toastr.error('You cannot change the Priority of inactive documents', '', { positionClass: 'toast-top-right' });        // this.Router.navigate(['/app-home'], { skipLocationChange: true });

   }
  }

  changeStatus(row: any, newStatus: string) {
    row.status = newStatus;
    const activeInactive = {
      Active: 'Active',
      Inactive: 'Inactive'
    }
    const userId = Number(sessionStorage.getItem('userId'));
    const payload = [{
      doc_id: row.doc_id__v,
      status: activeInactive[row.status],
      updated_by: userId
    }];
    this.veevaVaultService.updateStatus(payload).subscribe(response => {
      //this.loadProfiles();
      this.toastr.success(`Document ${activeInactive[row.status]} Successfully`, '', { positionClass: 'toast-top-right' });      // this.Router.navigate(['/app-home'], { skipLocationChange: true });
    });
  }
   toLower(value: string): string {
    return value.toLowerCase();
  }

  filterDataStatus (status: string) {
    this.filterData(status);
    this.status = status;
  }

  filterData(status: string) {
    if (this.dataSource.data.length > 0) {
    this.filteredDataSource.data = this.dataSource.data.filter(element => element.status === status);
    this.selection.clear();
   }
  }
  convertUtcToLocal(utcDateString: string): Date | null {
    if (!utcDateString) return null;
    const utcDate = utcDateString.split('.')[0] + 'Z';
    return new Date(utcDate);
  }


  changeStatusOfSelectedRows() {

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: { message: 'Are you sure you want to Change the status?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        const activeInactive = {
          Active: 'Inactive',
          Inactive: 'Active'
        }
        const selectedRows = this.selection.selected;
        const userId = Number(sessionStorage.getItem('userId'));
        const payload = {
          id: selectedRows.map(data => data.id),
          status: activeInactive[this.status],
          updated_by: `${userId}`
        };
        this.veevaVaultService.updateStatusActive(payload).subscribe(response => {
          if (response) {
            selectedRows.forEach(row => {
              row.status = row.status === 'Active' ? 'Inactive' : 'Active';

            });
            this.filterData(this.status);
            this.selection.clear();
            const activeInactiveMessage = {
              Active: 'Deactivated',
              Inactive: 'Activated'
            }
            this.toastr.success(`Document ${activeInactiveMessage[this.status]} Successfully`, '', { positionClass: 'toast-top-right' });

          }

        });
      }
    });


  }
 
}
